import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">A.P. Cool Service</h3>
            <p className="text-blue-100 mb-2">Door-to-Door Appliance Service</p>
            <p className="text-blue-100">Founded & Operated by Sachin Paswan</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <div className="space-y-2">
              <a
                href="https://wa.me/918655557727"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-blue-100 hover:text-white transition-colors"
              >
                <h3 className="text-xl font-bold mb-4">💬 WhatsApp Us</h3>
              </a>
            </div>
          </div>
        </div>

        {/* Religious Text */}
        <div className="text-center border-t border-blue-700 pt-6">
          <p className="text-2xl font-bold mb-4 text-yellow-300">
            || जय माता दी ||
          </p>
          <p className="text-blue-100">
            © {currentYear} A.P. Cool Service. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
